import { createContext, useContext } from 'react';
import light from './themes/light';

// Registry mirrors mobile's `theme/index.ts` shape — adding a theme later is
// "add one file + one registry line," not touching this provider.
export const themes = {
  light,
};

const ThemeContext = createContext(themes.light);

export function ThemeProvider({ children }) {
  // Web has no dark mode yet — always 'light'. When that changes, this is
  // the only place that needs to start reading a preference.
  return <ThemeContext.Provider value={themes.light}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
